"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListRowTitle = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _BrowserDefaultFocusStyleContext = require("../../contexts/BrowserDefaultFocusStyleContext.js");
var _KeyboardDetectionContext = require("../../contexts/KeyboardDetectionContext.js");
var _index = require("../ListRow/index.js");
var _index2 = require("../Text/index.js");
var _Link = require("../TextLink/Link.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _logging = require("../../logging.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
var _index3 = require("../../styles/index.js");
var _utils = require("../../utils.js");
var _excluded = ["lineClamp", "children", "variant", "weight", "as", "onClick", "aria-describedby", "id", "href"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LineClamp = _styledComponents["default"].span.withConfig({
  displayName: "ListRowTitle__LineClamp",
  componentId: "sc-1xe2if1-0"
})(["", ""], function (_ref) {
  var $lineClamp = _ref.$lineClamp;
  return (0, _styledComponents.css)(["display:", ";-webkit-line-clamp:", ";-webkit-box-orient:vertical;overflow:hidden;"], '-webkit-box', $lineClamp);
});
var ListRowText = (0, _styledComponents["default"])(_index2.Text).withConfig({
  displayName: "ListRowTitle__ListRowText",
  componentId: "sc-1xe2if1-1"
})(["outline:none;text-decoration:none;", ";&:focus{", "}"], (0, _index3.overflowWrapFlexText)(), function (props) {
  return props.$isUsingKeyboard && !props.$useBrowserDefaultFocusStyle && _Link.focusStyles;
});

/**
 * ListRowTitle is used as a slot default for ListRow title and can be used to create custom components.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-list-listrow-listrowtitle--docs) |
 * [Encore site](https://encore.spotify.net/web/components/lists) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/ListRowTitle)
 */
var ListRowTitle = exports.ListRowTitle = /*#__PURE__*/_react["default"].forwardRef(function ListRowTitle(_ref2, ref) {
  var lineClamp = _ref2.lineClamp,
    children = _ref2.children,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'bodyMedium' : _ref2$variant,
    weight = _ref2.weight,
    _ref2$as = _ref2.as,
    as = _ref2$as === void 0 ? 'p' : _ref2$as,
    onClick = _ref2.onClick,
    ariaDescribedby = _ref2['aria-describedby'],
    id = _ref2.id,
    href = _ref2.href,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var parentId = (0, _react.useContext)(_index.ListRowContext);
  var encoreId = parentId ? "listrow-title-".concat(parentId) : undefined;
  var encoreAriaDescribedby = parentId && onClick ? "onClickHint".concat(parentId) : undefined;
  var _useContext = (0, _react.useContext)(_KeyboardDetectionContext.KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = (0, _react.useContext)(_BrowserDefaultFocusStyleContext.BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  (0, _logging.warnLegacyTypeVariant)('ListRowTitle', variant, weight);
  return /*#__PURE__*/_react["default"].createElement(ListRowText, Object.assign({
    $isUsingKeyboard: isUsingKeyboard,
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    id: id || encoreId,
    forwardedAs: href ? 'a' : as,
    onClick: onClick,
    variant: (0, _utils.mapLegacyToTextVariant)(variant, weight),
    "aria-describedby": ariaDescribedby || encoreAriaDescribedby,
    ref: ref,
    href: href,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.ListRowTitle
  }, props), lineClamp ? /*#__PURE__*/_react["default"].createElement(LineClamp, {
    $lineClamp: lineClamp
  }, children) : children);
});